// Import core scripts
import "./main/core/accessibility.js";
import "./main/core/scrolling.js";
import { jumpTo } from './main/core/anchors';

// Import our layout scripts
//import './main/layout/header.js';
import './main/layout/footer.js';
import './main/ui/video.js';

// Import UI scripts
// import './main/ui/buttons.js';

// Import animation scripts
import './main/animations/fade-in.js';

document.addEventListener("DOMContentLoaded", () => {
  const siteHeader = document.querySelector(".site-header");
  let isFixed = false;
  const pageNavigation = document.querySelector('.sticky-offset-header');
  const updateStickyOffsets = () => {
    const top = siteHeader ? parseFloat(getComputedStyle(siteHeader).top) || 0 : 0;
    const height = siteHeader?.getBoundingClientRect().height || 0;
    document.documentElement.style.setProperty('--coto-sticky-header-offset', `${top + height}px`);
    document.documentElement.style.setProperty('--coto-page-navigation-height', `${pageNavigation?.getBoundingClientRect().height || 0}px`);
  };
  if (window.ResizeObserver) {
    const headerObserver = new ResizeObserver(updateStickyOffsets);
    if (siteHeader) headerObserver.observe(siteHeader);
    if (pageNavigation) headerObserver.observe(pageNavigation);
  }
  window.addEventListener('resize', updateStickyOffsets, { passive: true });
  updateStickyOffsets();

  // Debounce function
  const debounce = (func, delay) => {
    let timeout;
    return (...args) => {
      clearTimeout(timeout);
      timeout = setTimeout(() => func(...args), delay);
    };
  };

  // Scroll handler
  const handleScroll = () => {
    const currentScrollY = window.scrollY;

    if (siteHeader && currentScrollY > 200 && !isFixed) {
      // Add fixed-header if scrolling past 200px and not already fixed
      siteHeader.classList.add("fixed-header");
      isFixed = true;
    } else if (siteHeader && currentScrollY <= 100 && isFixed) {
      // Remove fixed-header if scrolling back above 200px
      siteHeader.classList.remove("fixed-header");
      isFixed = false;
    }
  };

  window.addEventListener("scroll", debounce(handleScroll, 5));
  handleScroll();


// Create back to top button element
    function createBackToTopButton() {
        // Create button element
        const backToTopBtn = document.createElement('button');
        backToTopBtn.id = 'back-to-top';
        backToTopBtn.className = 'back-to-top-btn';
        backToTopBtn.setAttribute('aria-label', 'Back to top');

        // Create SVG icon
        const svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        svg.setAttribute('width', '26');
        svg.setAttribute('height', '26');
        svg.setAttribute('viewBox', '0 0 26 26');
        svg.setAttribute('fill', 'none');
        svg.setAttribute('stroke', 'currentColor');
        svg.setAttribute('stroke-width', '2');
        svg.setAttribute('stroke-linecap', 'round');
        svg.setAttribute('stroke-linejoin', 'round');
        svg.setAttribute('aria-hidden', 'true');
        svg.setAttribute('focusable', 'false');

        const path = document.createElementNS('http://www.w3.org/2000/svg', 'path');
        path.setAttribute('d', 'M12 19V5M5 12l7-7 7 7');

        svg.appendChild(path);
        backToTopBtn.appendChild(svg);

        // Add text label
        const label = document.createElement('span');
        label.className = 'back-to-top-label';
        label.textContent = 'Back to top';
        backToTopBtn.appendChild(label);

        // Append to body
        document.body.appendChild(backToTopBtn);

        // Function to check and adjust position based on reCAPTCHA presence
        function checkRecaptchaAndAdjustPosition() {
            const recaptchaBadge = document.querySelector('.grecaptcha-badge[data-style="bottomright"]');
            if (recaptchaBadge) {
                backToTopBtn.style.bottom = '90px';
            }
        }

        // Initial check
        checkRecaptchaAndAdjustPosition();

        // Set up a MutationObserver to watch for DOM changes
        const observer = new MutationObserver(function(mutations) {
            checkRecaptchaAndAdjustPosition();
        });

        // Start observing the body for child additions
        observer.observe(document.body, { childList: true, subtree: true });

        // Also check after a few seconds (fallback)
        setTimeout(checkRecaptchaAndAdjustPosition, 3000);



        return backToTopBtn;
    }

    // Create the button
    const backToTopBtn = createBackToTopButton();

    // Show button when page is scrolled down
    const toggleBackToTopButton = () => {
        if (window.scrollY > 300) {
            Object.assign(backToTopBtn.style, {
                opacity: '1',
                visibility: 'visible'
            });
        } else {
            Object.assign(backToTopBtn.style, {
                opacity: '0',
                visibility: 'hidden'
            });
        }
    };

    // Scroll to top when button is clicked
    backToTopBtn.addEventListener('click', event => {
        const content = document.querySelector('main');
        if (content) {
            jumpTo(content, { keyboard: event.detail === 0 });
            return;
        }
        window.scrollTo({
            top: 0,
            behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'
        });
    });

    // Use the same debounce function you already have
    window.addEventListener('scroll', debounce(toggleBackToTopButton, 10));



  // Function to highlight active navigation item based on scroll position
  function updateNavigation() {
      // Get the sticky offset header and site header elements
      const stickyOffsetHeader = document.querySelector(
          ".sticky-offset-header"
      );
      const siteHeader = document.querySelector(".site-header");

      if (!stickyOffsetHeader || !siteHeader) return;

      // Get the heights dynamically, based on the current layout
      const stickyOffsetHeight =
          stickyOffsetHeader.getBoundingClientRect().height;
      const siteHeaderHeight = siteHeader.getBoundingClientRect().height;

      // Calculate total offset + 35px for padding
      const totalOffset = stickyOffsetHeight + siteHeaderHeight + 35;

      const navItems = document.querySelectorAll(".sticky-offset-items > p");

      // Get section selectors from anchor href attributes within these paragraphs
      const sectionSelectors = Array.from(navItems)
          .map((item) => {
              const anchor = item.querySelector("a");
              return anchor ? anchor.getAttribute("href") : null;
          })
          .filter((selector) => selector !== null);

      // Select corresponding sections
      const sections = sectionSelectors.map((selector) =>
          document.querySelector(selector)
      );

      // Get current scroll position
      const scrollPosition = window.scrollY;

      // Remove 'active' class from all nav items
      navItems.forEach((item) => item.classList.remove("active"));

      // Find the section currently in view
      for (let i = sections.length - 1; i >= 0; i--) {
          const section = sections[i];

          if (!section) continue;

          // Get section's position and height
          const sectionTop =
              section.getBoundingClientRect().top + window.scrollY;
          const sectionHeight = section.offsetHeight;

          // Use dynamically calculated offset instead of 275
          if (
              scrollPosition >= sectionTop - totalOffset &&
              scrollPosition < sectionTop + sectionHeight - totalOffset
          ) {
              navItems[i].classList.add("active");
              break;
          }
      }
  }


  // Add scroll event listener
  window.addEventListener('scroll', updateNavigation);

  // Initial call to set active state on page load
  window.addEventListener('load', updateNavigation);



  function adjustSidebarPosition() {
    const banner = document.getElementById('sitewide-banner');
    const header = document.getElementById('header-main-nav');
    const adminBar = document.getElementById('wpadminbar');
    const sidebar = document.getElementById('page-sidebar');
    
    if (sidebar) {
      // Initialize total height
      let totalHeight = 0;
  
      // Add admin bar height if it exists
      if (adminBar) {
        totalHeight += adminBar.getBoundingClientRect().height;
      }
  
      // Add banner height if it exists
      if (banner) {
        totalHeight += banner.getBoundingClientRect().height;
      }
  
      // Add header height if it exists
      if (header) {
        totalHeight += header.getBoundingClientRect().height;
      }
      
      // Set the top position dynamically
      sidebar.style.top = `${totalHeight}px`;
    }
  }
  
  // Call the function on page load
  window.addEventListener('load', adjustSidebarPosition);
  
  // Also call on window resize to handle responsive changes
  window.addEventListener('resize', adjustSidebarPosition);

});
